module.exports = __webpack_public_path__ + "static/media/ipnos-product-features-2.9a16e439.png";